// PrintTunggakan.js
// Reusable print preview for Tunggakan per zon report
import { apiGetTunggakanPerZon } from "../../api/tunggakan";

function fmt2(v) {
  return Number(v || 0).toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

export async function printTunggakanPreview(arrearsEnd) {
  if (!arrearsEnd) {
    throw new Error("Sila pilih Tarikh (Tunggakan).");
  }

  let { data = [], total = 0 } = await apiGetTunggakanPerZon(null, arrearsEnd);
  // Change 'Tidak Diketahui' to 'ZON TIDAK DIKETAHUI'
  data = data.map(r => ({
    ...r,
    zon: r.zon === 'Tidak Diketahui' ? 'ZON TIDAK DIKETAHUI' : r.zon
  }));
  const endLabel = new Date(arrearsEnd).toLocaleDateString("en-GB");
  const logoUrl = window.location.origin + "/build/kejora.png";

  const rowsHtml = data
    .map(
      (r, idx) => `
      <tr>
        <td style="text-align:center;">${idx + 1}</td>
        <td style="text-align:left;">${r.zon || ""}</td>
        <td style="text-align:right;">${fmt2(r.jumlah)}</td>
      </tr>`
    )
    .join("");

  const html = `
    <html>
      <head>
        <title>Laporan Tunggakan sehingga ${endLabel}</title>
        <style>
          @media print { @page { size: A4 portrait; margin: 15mm; } body { margin: 0; } }
          body { font-family: Arial, sans-serif; margin: 16px; }
          .header { text-align: left; margin-bottom: 10px; }
          .logo { width: 60px; vertical-align: middle; margin-right: 8px; }
          .title { font-weight: bold; display: inline-block; vertical-align: middle; }
          table { border-collapse: collapse; width: 420pt; margin-top: 8px; }
          th, td { border: 1px solid #000; padding: 6px 8px; font-size: 12px; }
          th { background: #e9e9f6; text-align: center; }
          tfoot td { font-weight: bold; }
        </style>
      </head>
      <body>
        <div class="header">
          <img class="logo" src="${logoUrl}" />
          <div class="title">
            <div>LEMBAGA KEMAJUAN JOHOR TENGGARA</div>
            <div>LAPORAN TUNGGAKAN SEHINGGA ${endLabel}</div>
          </div>
        </div>
        <table>
          <thead>
            <tr>
              <th style="width:24pt;">BIL</th>
              <th style="width:220pt;">ZON</th>
              <th style="width:120pt;">JUMLAH (RM)</th>
            </tr>
          </thead>
          <tbody>
            ${rowsHtml}
          </tbody>
          <tfoot>
            <tr>
              <td colspan="2" style="text-align:center;">JUMLAH (RM)</td>
              <td style="text-align:right;">${fmt2(total)}</td>
            </tr>
          </tfoot>
        </table>
        <script>
          function imagesLoaded(doc, cb){var imgs = doc.images; if(!imgs||!imgs.length) return cb(); var n=0; var fn=function(){ if(++n>=imgs.length) cb(); }; for(var i=0;i<imgs.length;i++){ if(imgs[i].complete) fn(); else imgs[i].addEventListener('load', fn, false); imgs[i].addEventListener('error', fn, false);} }
          imagesLoaded(document, function(){ window.print(); });
        </script>
      </body>
    </html>`;

  const win = window.open("", "_blank");
  win.document.open();
  win.document.write(html);
  win.document.close();
}

export default printTunggakanPreview;
